/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SearchSortBy {
    RECENTLY_ACTIVE = 'RECENTLY_ACTIVE',
    NEWEST = 'NEWEST',
}
